export const getSchemaProps = ({ schema = {}, value = {} } = {}) =>
  Object.fromEntries(Object.entries(value).filter(([key]) => schema[key]));
